<script setup lang="ts">
import CardDialog from '@/components/dialogs/CardDialog.vue'
import { postNativeMessage, STORE_LINKS } from '@/helpers/mobile'
import { useServiceStore } from '@/store/service'
import { computed, inject } from 'vue'

defineOptions({
  name: 'MobileWrapperVersionDialog'
})

const isAndroid = inject<boolean>('isAndroid', false)

const { service } = useServiceStore()

const applicationStorePage = computed<string>(() =>
  isAndroid ? STORE_LINKS.ANDROID[service] : STORE_LINKS.IOS[service]
)

const applicationPageOpened = (): void => {
  /*
   * Send mesasge to the native app that the application page was opened and it will close the app
   * so that it's updated when opened again
   */
  const message = JSON.stringify({
    type: 'ukkopro_update_application'
  })
  postNativeMessage(message)
}
</script>

<template>
  <CardDialog persistent :title="$t('mobile.wrapper_version_dialog.title')">
    <p>{{ $t('mobile.wrapper_version_dialog.description') }}</p>
    <template #actions>
      <PrimaryButton
        class="w-full"
        target="_blank"
        rel="noopener noreferrer"
        :href="applicationStorePage"
        :text="
          isAndroid
            ? $t('mobile.wrapper_version_dialog.action_text_android')
            : $t('mobile.wrapper_version_dialog.action_text_ios')
        "
        @click="applicationPageOpened"
      />
    </template>
  </CardDialog>
</template>
